import { terminalLines } from '@/data/siteContent'
import { TerminalLine } from './TerminalLine'

export function TerminalPanel() {
  return (
    <div className="glass-panel reveal reveal-delay-2 group mx-auto flex h-[350px] w-full max-w-2xl flex-col overflow-hidden rounded-lg border border-border transition duration-500 hover:border-primary/60">
      <div className="flex h-10 items-center justify-between border-b border-border bg-surface-container px-4">
        <div className="flex gap-2" aria-hidden="true">
          <span className="h-3 w-3 rounded-full bg-[#ff5f56]" />
          <span className="h-3 w-3 rounded-full bg-[#ffbd2e]" />
          <span className="h-3 w-3 rounded-full bg-[#27c93f]" />
        </div>
        <div className="font-mono text-[10px] uppercase tracking-tight text-muted/80">whoami — bash</div>
        <div className="w-12" />
      </div>
      <div className="flex-1 space-y-4 px-5 py-6 font-mono text-[13px] leading-relaxed text-foreground/90 sm:px-6 sm:text-sm">
        {terminalLines.map((line) => (
          <TerminalLine key={line.command} {...line} />
        ))}
        <div className="flex gap-3 pt-1">
          <span className="text-primary/70">$</span>
          <span className="animate-blink text-muted">_</span>
        </div>
      </div>
    </div>
  )
}
